var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"loader",class:_vm.className},[_c('div',{staticClass:"o-loader__inner"},[_c('span',{ref:"bg",staticClass:"o-loader__bg"}),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }